import { Component, Input, ElementRef, AfterViewInit, AfterContentInit, OnChanges, SimpleChanges } from '@angular/core';
declare var jQuery: any;


@Component({
    selector: 'gaweb-slick-slider',
    template: `
    <ng-content></ng-content>
  `,
    styles: [`
    /deep/ .trip-leg:focus{
      outline: none;
    }
  `]
})
export class SlickSliderComponent implements AfterContentInit {
    @Input() options: any;
    @Input() slickIndex: number;
    $element: any;

    defaultOptions: any = {};

    constructor(private el: ElementRef) {
    }

    ngAfterContentInit() {
        this.setUp();
    }
    private setUp() {
        for (var key in this.options) {
            this.defaultOptions[key] = this.options[key];
        }
        this.defaultOptions['initialSlide'] = !isNaN(this.slickIndex) ? this.slickIndex : 0;
        // this.$element = jQuery(this.el.nativeElement).slick(this.defaultOptions);
        this.$element = jQuery(this.el.nativeElement).slick({
            useTransform: true,
            arrows: false,
            draggable: false,
            accessibility: false,
            adaptiveHeight: false,
            centerMode: false,
            dots: false,
            cssEase: 'cubic-bezier(1, 0, 0, 1)'
        });
        this.animate();
    }
    // DO NOT PUT ANY TIMEOUT HERE IN ANY METHOD! If you need a timeout, put it outside the call.
    public refresh() {
        this.$element.slick('unslick');
        this.setUp();
        this.animate();

    }
    public slickNext() {
        this.$element.slick('slickNext');
        this.animate();
    }

    public slickPrev() {
        this.$element.slick('slickPrev');
        this.animate();
    }

    public close() {
        this.$element.slick('unslick');
    }
    private animate() {
        $('html, body').animate({ scrollTop: 0 }, 200);
    }

    public hide() {
        $('gaweb-slick-slider').css('display', 'none');
    }
    public show() {
        $('gaweb-slick-slider').css('display', 'block');
        this.$element.slick('setPosition');
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/slick-slider/slick-slider.component.ts